import { useCallback, useState } from 'react';

import { Button, ButtonSizeLG, ButtonSizeXL } from '@picsart/design-system/components/Button';

import { ANALYTICS_NAMES, editNowText } from 'templates/components/SingleTemplate/constants';

import { useTranslator } from '@picsart/rc/services/localization';
import useHandleEditClick from 'hooks/useHandleEditClick';

import useDevice from 'hooks/useDeviceType';
import { EDITOR_QUERY_NAME } from 'types/global';
import addAnalyticsParamsToUrl from 'utils/addAnalyticsParamsToUrl';
import useSingleTemplatesDataStore from 'templates/stores/singleTemplateDataStore';
import TemplateShareButton from '../TemplateShareButton';
import { EditAndShareProps } from './types';

import useStyles from './style';

const EditAndShare = ({ templateId, object_id }: EditAndShareProps) => {
  const { singleTemplateData } = useSingleTemplatesDataStore(state => ({
    singleTemplateData: state.singleTemplateData,
  }));
  const classes = useStyles();
  const translate = useTranslator();

  const [controlledExampleIsVisible, setControlledExampleIsVisible] = useState<boolean>(false);
  const { isMobile } = useDevice();
  const editClick = useHandleEditClick(isMobile);
  const singleTemplatePageUrl = window.location.href;

  const handleShareClick = useCallback(() => {
    setControlledExampleIsVisible(true);
  }, [setControlledExampleIsVisible]);
  const handlePopUpClick = useCallback(() => {
    setControlledExampleIsVisible(false);
  }, []);
  const handleEditClick = useCallback(
    e => {
      if (isMobile) {
        editClick(object_id, e, EDITOR_QUERY_NAME.template);
        return;
      }
      const formattedCategory = singleTemplateData?.subtypes[0]
        ? encodeURI(singleTemplateData?.subtypes[0].replace(/-/g, '+'))
        : '';

      window.open(
        addAnalyticsParamsToUrl(
          `/create/editor?template=${templateId}&category=templates${
            formattedCategory && `&templateSearch=${formattedCategory}`
          }`,
          {
            source: 'edit-and-share',
            origin: 'templates',
          },
        ),
        '_blank',
      );
    },
    [editClick, isMobile, object_id, templateId],
  );
  return (
    <div className={classes.editAndShareWrapper}>
      <Button
        className={classes.editBtn}
        onClick={handleEditClick}
        size={isMobile ? ButtonSizeLG : ButtonSizeXL}
        data-pulse-name={ANALYTICS_NAMES.EDIT_BUTTON}
      >
        {translate(editNowText)}
      </Button>
      <TemplateShareButton
        controlledExampleIsVisible={controlledExampleIsVisible}
        handlePopUpClick={handlePopUpClick}
        imageViewPageUrl={singleTemplatePageUrl}
        handleShareClick={handleShareClick}
      />
    </div>
  );
};
export default EditAndShare;
